import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import "./globals.css";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";


import ResetPassword from "./views/Auth/ResetPassword";


import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import AuthRoutes from "./components/PrivateRoute/AuthRoutes";



import LoginView from "views/Auth/LoginView";
import RegisterView from "views/Auth/RegisterView";
import ConfirmPassword from "views/Auth/ConfirmPassword";
import ResetPasswordSuccess from "views/Auth/ResetPasswordSuccess";




import HomepageView from "views/Homepage/homepageView";
import PrivacyPolicyView from "views/Homepage/PrivacyPolicyView";

import PersonalMyHome from "views/Personal/personalMyHome";
import PersonalAccountParameters from "views/Personal/personalAccountParameters";



import CorporateMyHome from "views/Corporate/corporateMyHome";
import UserManagement from "views/Corporate/userManagement";
import CorporateAccountParameters from "views/Corporate/corporateAccountParameters";
import TrainingCandidates from "views/Personal/Training/TrainingCandidates";
import TrainingOverView from "views/Personal/Training/TrainingOverView";
import TrainingForCandidatesDetails from "views/Personal/Training/TrainingDetailsForCandidates";
import TrainingSubscriptionsView from "views/Personal/Training/TrainingSubscriptionsView";
import "./i18n";


var user;
var homeRoute = "/home/homepage";
if (localStorage.getItem("user")) {
user = JSON.parse(localStorage.getItem("user"));
 } else {
 user = { role: "none" };
 };




ReactDOM.render(
  <BrowserRouter>
    <Switch>
      { /* <PrivateRoute path="/admin" component={AdminLayout} /> */ }
      { /* <PrivateRouteCandidat path="/candidat" component={CandidatLayout} /> */ }

      <Route path="/home/homepage" component={HomepageView} />
      <Route path="/home/privacy-policy" component={PrivacyPolicyView} />

      
      
      <Route path="/auth/login" component={LoginView} />
      <Route path="/auth/register" component={RegisterView} />
      <Route path="/auth/reset-password" component={ResetPassword} />
      <Route path="/auth/confirm-password/:token" component={ConfirmPassword} />
      

      

      

      

      <PrivateRoute path="/personal/homepage" component={PersonalMyHome} />
      <PrivateRoute path="/personal/parameters" component={PersonalAccountParameters} />
      <PrivateRoute path='/personal/trainings/:type' component={TrainingCandidates} />
      <PrivateRoute path='/personal/trainingOverview/:id' component={TrainingOverView} />
      <PrivateRoute path='/personal/trainingDetails/:id' component={TrainingForCandidatesDetails} />
      <PrivateRoute path='/personal/subscriptions' component={TrainingSubscriptionsView} />

      <Route path="/corporate/homepage" component={CorporateMyHome} />
      <Route path="/corporate/team" component={UserManagement} />
      <Route path="/corporate/parameters" component={CorporateAccountParameters} />
      
      


      <Redirect from="/" to={homeRoute} />

    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
